<template>
	<div class="ui-container">
		<slot></slot>
	</div>
</template>

<style scoped lang="scss">
.ui-container {
	width: 100%;
	max-width: 1200px;
	padding: 24px 16px;
}
</style>
